<template>
  <div>
    <header-component/>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 
            class="mb-0" 
            style="text-transform:capitalize;">Customer List</h3>
        </div>
        <el-table
          :data="customers"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column label="Name">
            <template
              slot-scope="scope"
            >{{ scope.row.firstName | capitalize }} {{ scope.row.lastName | capitalize }}</template>
          </el-table-column>
          <el-table-column 
            label="Gender" 
            prop="gender">
            <template slot-scope="scope">{{ scope.row.gender | capitalize }}</template>
          </el-table-column>
          <el-table-column 
            label="Phone" 
            prop="phone" />
          <el-table-column 
            label="Locality" 
            prop="locality" />
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown 
                slot="dropdown" 
                @command="command => handleAction(scope.row, command)">
                <el-button 
                  type="primary" 
                  size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu 
                  slot="dropdown" 
                  class="dropdown-menu dropdown-menu-arrow show">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="card-footer">
          <div
            v-if="meta"
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                Showing {{ meta.from + 1 }} to {{ meta.to }} of {{ meta.total }} entries
                <span
                  v-if="selectedRows.length"
                >&nbsp; &nbsp; {{ selectedRows.length }} rows selected</span>
              </p>
            </div>
            <pagination 
              :meta="meta" 
              @paginate="setPagination" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions } from "vuex";
import headerComponent from "../Components/HeaderComponent";
import pagination from "@/components/AmsaPagination";

export default {
  filters: {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name] : Button,
    "header-component": headerComponent,
    pagination,

  },
  data: () => {
    return {
      pageSize: 50,
      selectedRows : [],
      filters: {},
     };
  },

  computed: {
    ...mapGetters({
      customerList: "user/getCustomerList",
      user: "user/getUser"
    }),
    customers() {
      return this.customerList.rows
    },
    meta() {
      return this.customerList.meta
    }
  },
  beforeMount() {
    this.paginate();
  },

  methods: {
    ...mapActions({ getUsers: "user/getUsers", fetchUser: "user/fetchUser" }),
    handleAction(user, command) {
      if (command === "edit") {
        this.fetchUser(user.userId).then(res => {
          if(res) {
            this.$router.push("/users/add/" + user.userId);
          }
        });
      }
    },
    setPagination(data) {
      this.pageSize = data.perPage;
      this.paginate(data.page, this.filters);
    },
    paginate(page = 1, filters = {}) {
      let query = {
        page,
        perPage: this.pageSize,
        role : 'Customer',
        ...filters,
      };
      this.getUsers(query);
    },
  }
};
</script>